<template>
  <div class="mb-4 grid">
    <slot />
  </div>
</template>
